<template>
  <modal id="view-mode-modal" size="lg" :showClose="false" :showOkay="false">
    <template slot="title">{{ question.uniqueKey }}</template>
    <template slot="body">
      <trigger-container
        :dependencies="question.dependsOn"
        :display-type-key="question.FK_questionDisplayTypeKey"
        :timer="question.timer"
      />
      <view-mode :question="question" :character="character" :show-edit="false" />
    </template>
  </modal>
</template>

<script>
  import ViewMode from '@authoringPlatform/pages/Edit/pages/Inbox/MailView/ViewMode';
  import TriggerContainer from '@authoringPlatform/pages/Edit/pages/Inbox/MailView/TriggerContainer';

  import { mapState } from 'vuex';
  export default {
    props: ['question'],
    components: {
      ViewMode,
      TriggerContainer,
    },

    computed: {
      ...mapState('editMode/characters', ['characters']),

      character() {
        return this.characters[this.question.FK_authorKey];
      },
    },
  };
</script>

<style lang="scss" scoped></style>
